import React from 'react';
import { Home, Ruler, TreePine, Wrench } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Services = () => {
  const { language } = useLanguage();
  const t = translations[language].services;
  
  const services = [
    {
      icon: Home,
      title: t.customDesign.title,
      description: t.customDesign.description,
      features: t.customDesign.features
    },
    {
      icon: Ruler,
      title: t.planning.title,
      description: t.planning.description,
      features: t.planning.features
    },
    {
      icon: TreePine,
      title: t.sustainable.title,
      description: t.sustainable.description,
      features: t.sustainable.features
    },
    {
      icon: Wrench,
      title: t.construction.title,
      description: t.construction.description,
      features: t.construction.features
    }
  ];

  return (
    <section id="services" className="py-24 lg:py-32 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-20 fade-in">
          <p className="text-[#8B7355] text-sm tracking-widest uppercase mb-4">{t.sectionLabel}</p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-['Cormorant_Garamond'] font-light text-[#2c2c2c] mb-6">
            {t.title}
          </h2>
          <div className="w-24 h-0.5 bg-[#8B7355] mx-auto mb-8"></div>
          <p className="text-lg text-gray-600 leading-relaxed">
            {t.description}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <Card
                key={index}
                className="border-none shadow-lg hover-lift bg-[#FAFAF8] group overflow-hidden"
              >
                <CardHeader className="pb-4">
                  <div className="inline-flex items-center justify-center w-14 h-14 bg-white rounded-full mb-4 group-hover:bg-[#8B7355] transition-colors duration-300">
                    <Icon className="text-[#8B7355] group-hover:text-white transition-colors duration-300" size={24} />
                  </div>
                  <CardTitle className="text-2xl font-['Cormorant_Garamond'] font-semibold text-[#2c2c2c]">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-gray-600 leading-relaxed pt-2">
                    {service.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-3">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center space-x-3">
                        <div className="w-1.5 h-1.5 bg-[#8B7355] rounded-full"></div>
                        <span className="text-sm text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-20 text-center">
          <p className="text-gray-600 mb-6">
            {t.ctaText}
          </p>
          <button
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="bg-[#8B7355] hover:bg-[#6d5a42] text-white px-10 py-4 rounded-none transition-all duration-300 hover:shadow-xl text-lg font-light"
          >
            {t.ctaBtn}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;